<template>
  <div class="tabbar">
    <div
      class="itemWarp"
      :class="['font', { color: item.page === $route.path }]"
      v-for="(item, index) in tabbarDes"
      :key="index"
      @click="getVal(item)"
    >
      <!-- <img :src="item.page === $route.path ? item.activeImg : item.normalImg" alt="" /> -->
      <img v-if="index==0 && item.page === $route.path" class="icon" src="../../assets/img/icon/project_select.png"/>
      <img v-if="index==0 && item.page != $route.path" class="icon" src="../../assets/img/icon/project.png"/>
      <img v-if="index==1 && item.page != $route.path" class="icon" src="../../assets/img/icon/work.png"/>
      <img v-if="index==1 && item.page === $route.path" class="icon" src="../../assets/img/icon/work_select.png"/>
      <img v-if="index==2 && item.page === $route.path" class="icon" src="../../assets/img/icon/mine_select.png"/>
      <img v-if="index==2 && item.page != $route.path" class="icon" src="../../assets/img/icon/mine.png"/>
      <div>{{ item.txt }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "home",
      tabbarDes: [
        {
          txt: "ギャラリー",
          page: "/",
        },
        {
          txt: "chatで生成",
          page: "/chat",
        },
        {
          txt: "プロフィール",
          page: "/myCenter",
        }
      ]
    };
  },
  methods: {
    getVal(res) {
      // console.log(this.$route.path);
      this.selected = res.page;
      this.$router.push(res.page);
    }
  }
};
</script>

<style>
@media screen and (min-width: 1439px) {

  .itemWarp {
    height: 56px; /* no*/
    line-height: 18px; /* no*/
    cursor: pointer;
  }
  .tabbar .color {
    border-radius: 300px; /* no*/
  }
  .tabbar .itemWarp .icon {
    width: 24px; /* no*/
    height: 24px; /* no*/
    margin: 6px 0 0px 0; /* no*/
  }
}
@media screen and (max-width: 1439px) {
  .tabbar {
    /* width: 96%; */
    width: calc(100% - 40px);
    position: fixed;
    left: 15px;
    bottom: 18px;
    z-index: 90;
    border-radius: 34px;
    padding: 5px;
  }

  .itemWarp {
    border-radius: 30px;
    height: 60px;
    /* line-height: 60px; */
    font-size: 12px;
  }
  .tabbar .itemWarp .icon {
    width: 24px;
    height: 24px;
    margin: 8px 0 1px 0;
  }
}

.tabbar {
  display: flex;
  background: #fff;
}
.itemWarp {
  /* height: 56px;
    line-height: 56px; */
  /* height: 0.56rem; */
  /* line-height: 0.56rem; */
  /* height: 56px; */
  /* height: 0.32rem; */
  width: 33.3%;
  text-align: center;
    color: #232036;
}
.tabbar .color {
  background: #2b99ff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar/index.vue